<template>
  <zoovu-zoe
    :region="region"
    :api-key="apiKey"
    :locale="locale"
    :sku="identifier"
    :context="zoeContext"
    :dev="dev"
  >
  </zoovu-zoe>
</template>

<script>


export default {
	name: 'Zoe',
	props: ['identifier', 'zoeContext'],
	data() {
		return {
			region: 'eu',
			apiKey: 'beGFCzYzHXbbgtXzunAWK_-MGMQ',
			locale: 'en-US',
			dev: ''
		};
	},
	beforeMount() {
		const isDev = window.location.pathname.includes('dev');
		if (isDev) {
			this.region = 'us';
			this.apiKey = 'iLWXz5mQmdRrsiqhaFenDd0zm6w';
			this.locale = 'en-GB';
			this.dev = 'qa10';
		}
	}
};
</script>